export default __webpack_public_path__ + "static/media/up-arrow.28b8bb46.svg";